import HttpService from './http.service';

// Interfaz para la respuesta del endpoint /api/users/me
export interface UserProfile {
  business: number;
  leadPrice: number | undefined;
  id: string;
  email: string;
  name: string;
  lastName: string;
  profilePictureUrl: string;
  isActive: boolean;
  googleId?: string;
  role?: string;
  state?: string; // Estado del usuario (pending, active, etc.)
  category?: string;
  companyDescription?: string;
  documents?: any[];
  employeeCount?: number;
  leads?: number;
  legalRepId?: string;
  legalRepName?: string;
  locations?: any[];
  passwordHash?: string;
  phone?: string;
  profileImage?: string;
  serviceImages?: string[];
  services?: string[];
  termsAccepted?: boolean;
  yearsExperience?: number;
  // Otros campos que pueda devolver el backend
}

// Interfaz para crear un usuario básico
export interface BasicUserCreate {
  Email: string;
  Name: string;
  LastName: string;
  ProfilePictureUrl: string | null;
  IsActive: boolean;
  GoogleId?: string;
  State: string;
  Role: string;
  FirebaseToken?: string; // Token de Firebase para autenticación
  unitId?: string | null;
  entityId?: string | null;
}

// Servicio para operaciones relacionadas con el usuario
export const UserService = {
  // Obtener el perfil del usuario actual
  getCurrentUserProfile: async (): Promise<UserProfile> => {
    try {
      const response = await HttpService.get<UserProfile>('/api/users/me');
      if (response.data) {
        if (response.data.id) localStorage.setItem('company_id', response.data.id);
        if (response.data.role) localStorage.setItem('user_role', response.data.role);
      }
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Crear un usuario básico
  createBasicUser: async (userData: BasicUserCreate): Promise<any> => {
    try {
      const response = await HttpService.post('/api/users/basic', userData);
      localStorage.setItem('user_state', 'active');
      localStorage.setItem('is_new_user', 'false');
      return response;
    } catch (error) {
      throw error;
    }
  }
};

export default UserService;
